module.exports = __webpack_public_path__ + "img/feedback_wrong_discount_dark.a67cad0d.png";